var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('calc-method-cards',{attrs:{"active":2,"show-measured":_vm.$store.state.ratedCurrentIndex == 1},on:{"select":_vm.changeTab}})}
var staticRenderFns = []

export { render, staticRenderFns }